import { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/home";
import Search from "./components/Search";
import Profile from "./components/Profile";
import EditProfile from "./components/Profile/EditProfile";
import LikedHistory from "./components/Profile/LikedHistory";
import ListenHistory from "./components/Profile/ListenHistory";
import BookmarkedHistory from "./components/Profile/BookmarkedHistory";
import { Toaster } from "@/components/ui/toaster";
import { AudioPlayerProvider } from "./contexts/AudioPlayerContext";
import { AuthProvider } from "./contexts/AuthContext";
import LoadingScreen from "./components/ui/loading-screen";
import Login from "./components/Auth/Login";
import SignUp from "./components/Auth/SignUp";
import ResetPassword from "./components/Auth/ResetPassword";
import ConfirmEmail from "./components/Auth/ConfirmEmail";
import PodcastPage from "./components/PodcastPage";
import SharedPlayer from "./components/SharedPlayer";
import Dashboard from "./components/Analytics/Dashboard";
import { ErrorBoundary } from "./components/ui/error-boundary";

// Admin route guard component
const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  // We'll check isAdmin in the actual component to avoid flash of content
  return <>{children}</>;
};

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AudioPlayerProvider>
          <Suspense fallback={<LoadingScreen />}>
            <Routes>
              <Route path="/auth/confirm" element={<ConfirmEmail />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/player/:url" element={<SharedPlayer />} />
              <Route element={<Layout />}>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                <Route
                  path="/"
                  element={
                    <ErrorBoundary>
                      <Home />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/search"
                  element={
                    <ErrorBoundary>
                      <Search />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/podcast/:id"
                  element={
                    <ErrorBoundary>
                      <PodcastPage />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ErrorBoundary>
                      <Profile />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/profile/edit"
                  element={
                    <ErrorBoundary>
                      <EditProfile />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/profile/liked"
                  element={
                    <ErrorBoundary>
                      <LikedHistory />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/profile/bookmarked"
                  element={
                    <ErrorBoundary>
                      <BookmarkedHistory />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/profile/history"
                  element={
                    <ErrorBoundary>
                      <ListenHistory />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/analytics"
                  element={
                    <ErrorBoundary>
                      <AdminRoute>
                        <Dashboard />
                      </AdminRoute>
                    </ErrorBoundary>
                  }
                />
              </Route>
            </Routes>
          </Suspense>
          <Toaster />
        </AudioPlayerProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}


export default App;

